import Cookies from 'js-cookie';

export default class Handler {
  couponParamName = 'coupon';
  couponCookie = 'discount_code';
  checkoutButtons = [...document.getElementsByClassName('js-cart-popup__checkout-button')];

  load = () => {
    if (window.chCouponCode) {
      return window.chCouponCode;
    }

    const couponCode = this.getCouponCodeFromURL() || this.getCouponFromCookies();

    return window.chCouponCode = couponCode || '';
  };

  getCouponCodeFromURL = () => {
    const url = new URL(window.location);
    const couponCode = url.searchParams.get(this.couponParamName);

    if (couponCode) {
      Cookies.set(this.couponCookie, couponCode);
    }

    return couponCode;
  };

  getCouponFromCookies = () => Cookies.get(this.couponCookie);

  removeCouponFromCookies = () => {
    Cookies.remove(this.couponCookie);
  };
}
